//const API_URL = 'http://localhost:5001/api';
const API_URL = 'https://renewal-api-uat-gsdjggd6d6hcfugq.eastus-01.azurewebsites.net/api';
const WEB_URL = 'https://test-renewal.claritybenefitsolutions.com'
//const WEB_URL = 'http://localhost:3000'
export default {
  API_URL,
  WEB_URL
};